import BasicSetupDetails from "./BasicSetupDetails";

export default BasicSetupDetails;